import React from 'react'

const Explanation = ({photoData}) => {
  return (
    <div>
      <p>{photoData}</p>
    </div>
  )
}

export default Explanation